const bus = {
  handler: null,

  setHandler(cb) {
    bus.handler = cb
  },

  show(message, opts = {}) {
    if (typeof bus.handler === 'function') {
      bus.handler(message, opts)
    }
  }
}

export default bus
